import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ShouldMigrateDTO} from '../model/shouldMigrateDTO';

@Injectable({
  providedIn: 'root'
})
export class MigrationService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'migrations';

  constructor(private http: HttpClient) {
  }

  shouldMigrate(clientId) {
    return this.http.get<ShouldMigrateDTO>(`${this.path}/should-migrate/client/${clientId}`);
  }

}
